var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('am2-tag',{style:({
    padding: "8px 15px 8px 15px",
  }),attrs:{"text":_vm.text,"type":_vm.type,"shape":"round","icon-name":_vm.iconName,"icon-animation":_vm.iconAnimation,"icon-props":{
    height: '10px',
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }